import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Silkscreen, monospace",
  },
});

export default theme;
